import React, { useState,useEffect, useRef } from 'react'
import { useReactToPrint } from 'react-to-print';
import { useParams } from 'react-router-dom'
import CRMLayout from '../../../../../../layout/components/CRMLayout';
import proposalServices from '../proposalServices';
import { useAlert } from '../../../../../../context/AlertContext';

import { useAppData } from '../../../../../../context/AppDataContext';
import ProposalItemList from '../section/ProposalItemList';
import companyServices from '../../../finance/company/companyServices';
import LatterHead from '../section/LatterHead';
import { Print } from '@mui/icons-material';
import ContentSection from '../section/ContentSection';
import ProposalForm from '../component/ProposalForm';
import InlineEdit from '../section/InlineEdit';
import exposrtTableDataToCsv from '../../../../../../utils/exposrtTableDataToCsv';


function ProposalDetailsPage() {
  const {id} = useParams();
  const printComponentRef = useRef();
  const tableRef = useRef();
  
  const {AppAlert} = useAlert();
  
  
  const [loading,setLoadingStatus] = useState(false)
  const [isPrinting,setIsPrinting] = useState(false);
  const {productList,getProductList} = useAppData();
  const [proposalDetails,setProposalDetails] = useState(null);
  const [companyDetails,setCompanyDetails] = useState(null);

  

  const getComapnyDetails = () =>{
        console.log(proposalDetails);
        companyServices.getById(proposalDetails.companyId).then(res=>{
            setCompanyDetails(res.data);
        }).catch(error=>{
        }).finally(()=>{
        })
    }

    useEffect(()=>{
        if(proposalDetails){
            getComapnyDetails();
        }
    },[proposalDetails])

  const getProposalDetails = () =>{
    setLoadingStatus(true);
    proposalServices.getById(id).then(res=>{
      setProposalDetails(res.data);
    }).catch(error=>{

    }).finally(()=>{
      setLoadingStatus(false);
    })
  }

  useEffect(()=>{
    getProposalDetails();
    getProductList();
  },[id])

  const printProposal = () =>{
    setIsPrinting(true);
    setTimeout(handlePrint,100)
  }
  const handlePrint = useReactToPrint({
    onBeforePrint :() =>{
      setIsPrinting(true);
    },
    onAfterPrint : ()=>{
      setIsPrinting(false);
    },
    content: () => printComponentRef.current,
    // Standard A4 or Letter size logic
    pageStyle: `
        @page { 
            size: auto; 
            margin: 10mm; 
        }
        @media print {
            body { -webkit-print-color-adjust: exact; }
        }
    `
  });
  
  const updateProposalDetails = (payload) =>{
    payload.id = proposalDetails.id;
    console.log(payload);
    proposalServices.save(payload).then(res=>{
      AppAlert("Proposal Details updated");
      getProposalDetails();
    }).catch(error=>{
      console.log(error);
    })
  }

  const handleCSVExport = () =>{
    setIsPrinting(true);
    const table = tableRef.current;
    setTimeout(()=>{
      exposrtTableDataToCsv(table,"proposal_"+id)
      setIsPrinting(false);
    },100)
    
  }


  return (
    <CRMLayout>
      <style>
        {
          `
          table {page-break-after:unset}
          `
        }
      </style>
      <div className='row mb-3'>
        <div className='col-md-6'>
        </div>
        <div className='col-md-6'>
          <button className='btn btn-outline-primary float-end ms-2' onClick={handleCSVExport}>Export to CSV</button>
          <button className='btn btn-outline-primary float-end ms-2' onClick={printProposal} ><Print /> Print</button>
        </div>
      </div>
      <div ref={printComponentRef} >
        <LatterHead companyDetails={companyDetails} />
        <div className='row'>
          <div className='col-md-12'>
            <div className='text-center mt-3'>
                <ContentSection 
                  caption={"Heading"}
                  field={"heading"}
                  value={proposalDetails?.heading}
                  callBack={updateProposalDetails}
                  isPrinting={isPrinting}
                />
            </div>
          </div>
          <div className='col-md-12'>
            <div className='text-center'>
                <ContentSection 
                  caption={"Sub Heading"}
                  field={"subHeading"}
                  value={proposalDetails?.subHeading}
                  callBack={updateProposalDetails}
                  isPrinting={isPrinting}
                />
            </div>

            <div className=''>
                <ContentSection 
                  caption={"Refer To"}
                  field={"reference"}
                  value={proposalDetails?.reference}
                  callBack={updateProposalDetails}
                  isPrinting={isPrinting}
                />
            </div>

          </div>
        </div>
        <div className='row'>
          <div className='col-6'></div>  
          <div className='col-6'>
            <span className='float-end'>
            Date: <InlineEdit
                    caption={"Proposal Date"}
                    field={"proposalDate"}
                    value={proposalDetails?.proposalDate}
                    callBack={updateProposalDetails}
                    isPrinting={isPrinting}
                    inputType={"date"}
                  />
            </span>
          </div>
        </div>
      
        <div className='row'>
          <div className='col-md-12 mt-2'>
              { proposalDetails && productList &&
                <ProposalItemList
                  proposalDetails={proposalDetails} productList={productList} isPrinting={isPrinting} tableRef={tableRef}
                />
              }
          </div>
        </div>

        <div className='row'>
          
          <div className='col-md-12 pt-2'>
            <ContentSection 
              caption={"Narration"}
              field={"narration"}
              value={proposalDetails?.narration}
              callBack={updateProposalDetails}
              isPrinting={isPrinting}
            />
          </div>
          
          <div className='col-md-12 pt-2'>
            <ContentSection 
              caption={"Terms And Conditions"}
              field={"conditions"}
              value={proposalDetails?.conditions}
              callBack={updateProposalDetails}
              isPrinting={isPrinting}
            />
          </div>

          <div className='col-md-12 pt-2'>
            <ContentSection 
              caption={"Payment Terms"}
              field={"paymentTerms"}
              value={proposalDetails?.paymentTerms}
              callBack={updateProposalDetails}
              isPrinting={isPrinting}
            />
          </div>


          <div className='col-md-12 pt-2'>
            <ContentSection 
              caption={"Footer Section 1"}
              field={"footer1"}
              value={proposalDetails?.footer1}
              callBack={updateProposalDetails}
              isPrinting={isPrinting}
            />
          </div>

          <div className='col-md-12 pt-2'>
            <ContentSection 
              caption={"Footer Section 2"}
              field={"footer2"}
              value={proposalDetails?.footer2}
              callBack={updateProposalDetails}
              isPrinting={isPrinting}
            />
          </div>


          <div className='col-md-6'>
          </div>
          <div className='col-md-6'>
            <div className='card border-0' style={{fontSize:12}}>
                <div className='card-body p-1'>
                <div className='float-end'>
                    <div className='fw-bold'>for {companyDetails?.companyName}</div>
                    <img src={companyDetails?.authSign} style={{ maxWidth:".75in",maxHeight:".75in",}} />
                    <div>Authorised Signatory</div>
                </div>
                </div>
            </div>
          </div>


        </div>
      </div>
    </CRMLayout>
  )
}

export default ProposalDetailsPage